import React from 'react';
import './styles.scss';

import sphereAsset from './assets/sphere.png';

// Icon is a namespace of decorative icon "frames". Each variant wraps a child
// icon (MUI icon, svg, img, etc.) inside a styled container. Start with Sphere.
const Icon = {};

// Renders the child icon centered on top of the sphere.svg background.
// `size` is the px dimension of the sphere (number -> px, string -> used as-is).
Icon.Sphere = ({ size = 42, children, className = '', style, ...props }) => {
    const dimension = typeof size === 'number' ? `${size}px` : size;
    const iconSize = typeof size === 'number' ? `${size * 0.5}px` : undefined;
    const iconStyle = iconSize ? { width: iconSize, height: iconSize, fontSize: iconSize } : undefined;

    return (
        <div
            {...props}
            className={`icon-sphere ${className}`.trim()}
            style={{
                width: dimension,
                height: dimension,
                backgroundImage: `url(${sphereAsset})`,
                ...style,
            }}
        >
            {/* Blurred duplicate sitting behind the icon to read as a soft drop shadow. */}
            <span className="icon-sphere__icon icon-sphere__icon--shadow" style={iconStyle} aria-hidden="true">
                {children}
            </span>
            <span className="icon-sphere__icon" style={iconStyle}>
                {children}
            </span>
        </div>
    );
};

export default Icon;
